const animationIntroductionEffect = () => {
	const intro = document.getElementById('introduction');

	if (intro) {
	
		const mediaQuery = window.matchMedia('(min-width: 1024px)');
		const breadcrumb = intro.querySelector('.breadcrumb-content');
		const paragraph = intro.querySelectorAll('.introduction-content p');
		let delay;
		let offset;

		if (mediaQuery.matches) {
			delay = 0;
			offset = 100;
		} else {
			delay = 0.25;
			offset = 0;
		}

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: intro,
				start: `top bottom-=${offset}`, // the default values
				//markers: true,
			},
		});

		tl.to(intro, {
			duration: 0.5,
			delay: delay,
			scale: 1,
			autoAlpha: 1,
			transformOrigin: 'center center',
			ease: 'power4.out',
		});

		if (breadcrumb) {
			tl.from(
				breadcrumb,
				{
					duration: 0.5,
					y: +40,
					autoAlpha: 0,
					ease: 'power2.out',
				},
				'>-0.2'
			);
		}

		tl.from(
			paragraph,
			{
				duration: 0.5,
				y: +40,
				autoAlpha: 0,
				ease: 'power2.out',
				stagger: 0.2,
			},
			'>-0.2'
		);

		return tl;
	}
};

export default animationIntroductionEffect;
